import * as React from 'react';

import { Typography, Radio, RadioGroup, TextField, Checkbox, FormControlLabel, InputLabel, FormGroup, Grid, Box, FormControl, Button, MenuItem, Select } from '@mui/material';

function CommonSettings() {
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>共通</legend>
      <Grid container spacing={2}>
        <Grid container item>
          <FormControlLabel control={<Checkbox />} label="CH1" />
          <FormControlLabel control={<Checkbox />} label="CH2" />
        </Grid>
        <React.Fragment>
          <Grid container item xs={3}>
            <TextField fullWidth label="電源待ち時間[ms]" size="small" id="outlined-basic" variant="outlined" type="number" value={6} />
          </Grid>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>変換クロック</InputLabel>
              <Select
                label="変換クロック"
                value={0}
              >
                <MenuItem value={0}>9MHz(ZG3)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={3}>
            <TextField fullWidth label="DAC待ち時間[ms]" size="small" id="outlined-basic" variant="outlined" type="number" value={4} />
          </Grid>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>ACQサイクル</InputLabel>
              <Select
                label="ACQサイクル"
                value={0}
              >
                <MenuItem value={0}>16Cycle(ZG3)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </React.Fragment>
        <React.Fragment>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>オーバーサンプリング</InputLabel>
              <Select
                label="オーバーサンプリング"
                value={0}
              >
                <MenuItem value={0}>×32</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </React.Fragment>
      </Grid>
    </Box>
  );
}

function MeasurementSettings() {
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>測定</legend>
      <Grid container spacing={2}>
        <Grid container item>
          <Button variant="contained" disabled>実行</Button>
          <Grid item xs={0.2} />
          <Button variant="contained" disabled>中断</Button>
        </Grid>
        <React.Fragment>
          <Grid container item xs={3}>
            <TextField fullWidth label="開始タイミング[s]" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
          <Grid container item xs={3}>
            <TextField fullWidth label="測定間隔[ms]" size="small" id="outlined-basic" variant="outlined" type="number" value={100} />
          </Grid>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>DAC OFFモード</InputLabel>
              <Select
                label="DAC OFFモード"
                value={0}
              >
                <MenuItem value={0}>PD(3-State)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={3}>
            <TextField fullWidth label="測定回数" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
        </React.Fragment>
        <React.Fragment>
          <Grid container item xs={3}>
            <TextField fullWidth label="補正間隔" size="small" id="outlined-basic" variant="outlined" type="number" value={0} />
          </Grid>
          <Grid container item xs={3}>
            <FormControlLabel control={<Checkbox />} label="無制限" />
          </Grid>
        </React.Fragment>
      </Grid>
    </Box>
  );
}

function CalibrationSettings() {
  const chSetting = (ch: number) => {
    return (
      <Box sx={{ border: 1, borderRadius: 1 }} component={'fieldset'} width={'75%'}>
        <legend>CH{ch}</legend>
        <Grid container spacing={2}>
          <Grid container item xs={4}>
            <TextField fullWidth label="DAC" size="small" id="outlined-basic" variant="outlined" type="number" value={800} />
          </Grid>
          <Grid container item xs={4}>
            <TextField fullWidth label="初期ブリッジ電圧[V]" size="small" id="outlined-basic" variant="outlined" type="number" value={'1.250000'} />
          </Grid>
          <Grid container item xs={1.7}>
            <Button variant="contained" disabled>設定</Button>
          </Grid>
          <Grid container item xs={1.7}>
            <Button variant="contained" disabled>取得</Button>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>キャリブレーション</legend>
      <Grid container spacing={2}>
        <Grid container item xs={1.3}>
          <Button variant="contained" disabled>実行</Button>
        </Grid>
        <Grid container item xs={1.5}>
          <Button variant="contained" disabled>中断</Button>
        </Grid>
        <Grid container item>
          {chSetting(1)}
        </Grid>
        <Grid container item>
          {chSetting(2)}
        </Grid>
        <Grid container item xs={1.3}>
          <Button fullWidth variant="contained" disabled>保存</Button>
        </Grid>
        <Grid container item xs={1.8}>
          <Button fullWidth variant="contained" disabled>読み出し</Button>
        </Grid>
        <Grid container item xs={1.8}>
          <Button fullWidth variant="contained" disabled>リセット</Button>
        </Grid>
      </Grid>
      
    </Box>
  );
}

function DebugSettings() {
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>Debug</legend>
      <Grid container spacing={2}>
        <Grid container item xs={1.5}>
          <Typography gutterBottom sx={{ marginTop: 1 }}>時刻変更</Typography>
        </Grid>
        <Grid container item xs={3}>
          <TextField fullWidth size="small" id="outlined-basic" variant="outlined" type="number" value={0} />
        </Grid>
          <Grid container item xs={3}>
            <TextField fullWidth size="small" id="outlined-basic" variant="outlined" type="number" value={0} />
          </Grid>
          <Grid container item xs={3}>
            <Button variant="contained" disabled>変更</Button>
          </Grid>
      </Grid>
    </Box>
  );
}

export default function TpIfaDriver() {
  return (
    <Box width={'60%'}>
      <CommonSettings />
      <MeasurementSettings />
      <CalibrationSettings />
      <DebugSettings />
    </Box>
  );
}
